import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import { messageInfo } from "@utils/message";
import liff from '@line/liff'
import lineGetProfileAndLogin from "@utils/line-get-profile-and-login";
import Vue from 'vue';
import router from '@router'

export default [
  // ===
  // 登入
  // ===
  {
    path: '/shop/login',
    name: 'shop-login',
    component: () => lazyLoadView(import('@views/Wordpress/Login/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isLogoutWordpressPage: true,
      showRightToolBox: false,
    }
  },
  // ===
  // 登出
  // ===
  {
    path: '/shop/logout',
    name: 'shop-logout',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          const shopUrl = window.globalData.APP_SHOP_URL
          const { href } = router.resolve({
            name: 'shop-login',
            query: {
              liffUserId: routeTo.query.liffUserId || undefined,
              redirectFrom: routeTo.query.redirectFrom || undefined,
            }
          });

          await Promise.all([
            store.dispatch('auth/logOut'),
            store.dispatch('order/clearApplicablePrepaidOrderList'),
            store.dispatch('auth/wordpressLogOut', {
              redirect: routeTo.query.redirectFrom ? `${window.location.origin}${href}` : shopUrl
            })
          ]);
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isNullPage: true,
    },
  },
  // ===
  // LIFF
  // ===
  {
    path: '/shop/liff/:liffId',
    name: 'shop-liff',
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          liff.init({
            liffId: routeTo.params.liffId
          })
            .then(() => {
              /* liff.sendMessages([{
               type: 'text',
               text: "test"
               }]); */

              if(liff.isLoggedIn() || (!liff.isLoggedIn() && liff.isInClient())) {
                lineGetProfileAndLogin({
                  liffId: routeTo.params.liffId,
                  redirectFrom: routeTo.query.redirectTo,
                  next
                })
              } else {
                liff.login({ redirectUri: window.location.href })
              }
            })
            .catch((error) => {
              console.log(error);
            });
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
      isNullPage: true,
    },
  },
]
